import { Grid } from '@mui/material';
import SignInForm from '@/components/singIn/signIn';

const LoginPage = () => {
  return (
    <Grid container justifyContent="center" alignItems={'flex-start'} spacing={4}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SignInForm />
      </Grid>
    </Grid>
  );
};

export default LoginPage;
